'use client';

import { FullControlEditor } from '../components';

export default function CreatePage() {
  return <FullControlEditor mode="create" canEdit={true} />;
}
